import request from "@/utils/request";

// 登录
export function login (data) {
    return request({
        url: "/user/login",
        method: "post",
        data
    });
}


// 当前用户获取个人信息   
export function userInfo (data) {
    return request({
        url: "/user/person/findPersonInfo",
        method: "post",
        data
    });
}
// export function getInfo (token) {
//     return request({
//         url: "/vue-element-admin/user/info",
//         method: "get",
//         params: { token }
//     });
// }
